var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RechargeView"},[_c('RechargeForm',{attrs:{"min-amount":_vm.settings.min_amount_recharge,"max-amount":_vm.settings.max_amount_recharge,"promotions":_vm.settings.promotions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }